import _ from "lodash";
import { friendlyCountriesCodes } from "../config";
import {
  ALL_COUNTRY,
  DOMESTIC_DOCS_COUNTRIES,
  FRIENDLY_COUNTRY,
  NP,
  NP_ID,
  NP_SR,
  ONLY_RU_COUNTRY,
  RU,
} from "../constants";

export const getRoutesCountries = (routes, included) => {
  let airportList = [];

  _.map(routes, function (route) {
    _.map(route.segments, function (segment) {
      airportList = [...airportList, segment.arrival.airport, segment.departure.airport];
    });
  });

  airportList = _.uniq(airportList);

  return _.uniq(
    _.compact(
      _.map(airportList, function (item) {
        return included?.airport?.[item]?.country;
      })
    )
  );
};

// Внутренний рейс по стране из DOMESTIC_DOCS_COUNTRIES получает собственный flightType,
// чтобы форма могла сверить страну маршрута с гражданством пассажира.
export const getDomesticDocsFlightType = countryCode => `ONLY_${countryCode}_COUNTRY`;

export const getDomesticDocsCountry = flightType =>
  _.find(DOMESTIC_DOCS_COUNTRIES, code => getDomesticDocsFlightType(code) === flightType) || null;

// NP_ID и NP_SR существуют только внутри формы бронирования, чтобы ID card и свидетельство
// о рождении были отдельными пунктами списка. Бэкенд знает их все как NP.
export const getApiDocumentType = documentType =>
  documentType === NP_ID || documentType === NP_SR ? NP : documentType;

export const getFlightDocsType = routesCountries => {
  // Справочник отдаёт коды стран в верхнем регистре ("RU"), приводим к нему обе стороны.
  const singleCountry = routesCountries.length === 1 ? _.toUpper(_.first(routesCountries)) : null;

  if (singleCountry === RU) {
    return ONLY_RU_COUNTRY;
  }

  if (_.includes(DOMESTIC_DOCS_COUNTRIES, singleCountry)) {
    return getDomesticDocsFlightType(singleCountry);
  }

  let isFriendly = true;

  _.forEach(routesCountries, function (item) {
    if (
      _.findIndex(friendlyCountriesCodes, function (o) {
        return o === item;
      }) === -1
    ) {
      isFriendly = false;
    }
  });

  return isFriendly ? FRIENDLY_COUNTRY : ALL_COUNTRY;
};

export const normalizePhone = phone => {
  const formattedPhone = phone.replace(/[^\d]/g, "");

  return `+${formattedPhone}`;
};
